<template>
  <div v-if="cardTypeList.length > 0" class="pack_menu_list">
    <div
      v-for="cardType in cardTypeList"
      :key="cardType.id"
      class="pack_menu"
      :class="{ active: showCardType == cardType.id, bonus: cardType.id === 999995 }"
      @click="selectPackType(cardType.id)"
    >{{ cardType.name }}</div>
    <!-- 空の要素で4の倍数に揃える -->
    <div
      v-for="n in emptySlots"
      :key="'empty-' + n"
      class="pack_menu empty"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      showCardType: 'pack/topCardType',
    }),
    // 4の倍数に揃えるための空スロット数
    emptySlots() {
      const count = this.cardTypeList.length;
      if (count === 0) return 0;
      const remainder = count % 4;
      return remainder === 0 ? 0 : 4 - remainder;
    },
  },
  props: {
    cardTypeList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    selectPackType(type) {
      this.$store.dispatch('pack/setTopCardType', type);
    },
  },
};
</script>

<style lang="scss" scoped>
.pack_menu_list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: $white;
  margin: 0 0 20px 0;
  flex-wrap: wrap;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  clip-path: inset(0 0 -10px 0);
  position: relative;

  .pack_menu {
    color: $black;
    flex: 0 0 25%;
    max-width: 25%;
    height: 70px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: .2s;
    font-weight: bold;
    font-size: 14px;
    box-sizing: border-box;
    background-color: $white;

    &:hover {
      background-color: #f0f0f0;
    }

    &.active {
      background-color: #e8e8e8;
      border-bottom: 5px solid #e53935;
    }

    &.empty {
      cursor: default;
      &:hover {
        background-color: $white;
      }
    }

    &.bonus {
      color: transparent;
      background: linear-gradient(to bottom, #ffe600, #cc5500);
      background-clip: text;
      -webkit-background-clip: text;
      font-weight: 900;
      text-transform: uppercase;

      &.active {
        background: linear-gradient(to bottom, #ffe600, #cc5500), #e8e8e8;
        background-clip: text, padding-box;
        -webkit-background-clip: text, padding-box;
      }
    }
  }
}

@media screen and (max-width: $tabletWidth) {
  .pack_menu_list {
    justify-content: flex-start;
    .pack_menu {
      height: 54px;
      flex: 0 0 25%;
      max-width: 25%;
      font-size: 12px;
    }
  }
}

@media screen and (max-width: 480px) {
  .pack_menu_list {
    justify-content: flex-start;
    .pack_menu {
      height: 48px;
      font-size: 10px;
    }
  }
}
</style>
